export const FIELD_TYPE_CHECKBOX_GROUP = 'checkbox-group';
export const FIELD_TYPE_TEXT_AREA = 'textarea';
export const FIELD_TYPE_TEXT = 'text';
export const FIELD_TYPE_NUMBER = 'number';
export const FIELD_TYPE_DATE = 'date';
export const FIELD_TYPE_HEADER = 'header';
export const FIELD_TYPE_SELECT = 'select';

